import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    legalArea: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message. We will get back to you within 24 hours!');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      legalArea: ''
    });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero full-width-section">
        <div className="contact-hero-full-width">
          <div className="section-container">
            <div className="contact-hero-content">
              <h1 className="page-title">Contact Us</h1>
              <p className="page-subtitle">
                Get in touch for professional legal consultation and assistance
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="contact-main full-width-section">
        <div className="section-container">
          <div className="contact-content-grid">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2 className="section-title">Get In Touch</h2>
              <div className="title-underline"></div>
              <p className="contact-intro">
                Ready to discuss your legal needs? We're here to help you navigate 
                your legal challenges with professional expertise and personalized attention.
              </p>
              
              <div className="contact-cards">
                <div className="contact-card">
                  <div className="contact-icon" style={{'--contact-color': 'var(--accent-blue)'}}>
                    📞
                  </div>
                  <div className="contact-details">
                    <h3>Phone</h3>
                    <p className="contact-value">0333-7125176</p>
                    <span className="contact-note">Available Mon-Fri 9AM-6PM</span>
                  </div>
                </div>
                
                <div className="contact-card">
                  <div className="contact-icon" style={{'--contact-color': 'var(--accent-teal)'}}>
                    ✉️
                  </div>
                  <div className="contact-details">
                    <h3>Email</h3>
                    <p className="contact-value">ambreendaudpota@gmail.com</p>
                    <span className="contact-note">We respond within 24 hours</span>
                  </div>
                </div>
                
                <div className="contact-card">
                  <div className="contact-icon" style={{'--contact-color': 'var(--accent-purple)'}}>
                    📍
                  </div>
                  <div className="contact-details">
                    <h3>Office Address</h3>
                    <p className="contact-value">Quresh Law Chamber</p>
                    <p className="contact-value">Station Road Sukkur</p>
                    <span className="contact-note">Visit by appointment</span>
                  </div>
                </div>
                
                <div className="contact-card">
                  <div className="contact-icon" style={{'--contact-color': 'var(--accent-orange)'}}>
                    ⏰
                  </div>
                  <div className="contact-details">
                    <h3>Office Hours</h3>
                    <p className="contact-value">Monday - Friday</p>
                    <p className="contact-value">9:00 AM - 6:00 PM</p>
                    <span className="contact-note">Emergency consultations available</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Contact Form */}
            <div className="contact-form-section">
              <div className="form-wrapper">
                <h3>Send Us a Message</h3>
                <p>Fill out the form below and we'll get back to you as soon as possible.</p>
                
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="your.email@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number *</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Your phone number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="legalArea">Legal Area</label>
                    <select
                      id="legalArea"
                      name="legalArea"
                      value={formData.legalArea}
                      onChange={handleChange}
                    >
                      <option value="">Select legal area (optional)</option>
                      <option value="civil-litigation">Civil Litigation</option>
                      <option value="criminal-defense">Criminal Defense</option>
                      <option value="family-law">Family Law</option>
                      <option value="corporate-law">Corporate Law</option>
                      <option value="property-law">Property Law</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      placeholder="Brief subject of your inquiry"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Please describe your legal matter in detail..."
                      rows="6"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  
                  <button type="submit" className="btn btn-primary submit-btn">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="contact-why-choose full-width-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Why Choose Our Legal Services?</h2>
            <p className="section-subtitle">
              Professional legal representation you can trust
            </p>
          </div>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">🎯</div>
              <h3>Expert Legal Advice</h3>
              <p>Get professional legal guidance from an experienced High Court advocate.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">⚡</div>
              <h3>Quick Response</h3>
              <p>We respond to all inquiries within 24 hours and offer urgent consultations.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🤝</div>
              <h3>Personalized Service</h3>
              <p>Every case receives individual attention with customized legal strategies.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🛡️</div>
              <h3>Confidential Consultation</h3>
              <p>All consultations are completely confidential and protected by attorney-client privilege.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency Contact */}
      <section className="emergency-contact full-width-section">
        <div className="section-container">
          <div className="emergency-content">
            <div className="emergency-text">
              <h2>Need Urgent Legal Assistance?</h2>
              <p>For emergency legal matters that require immediate attention, contact us directly.</p>
            </div>
            <div className="emergency-action">
              <a href="tel:03337125176" className="btn btn-secondary emergency-btn">
                📞 Call Now: 0333-7125176
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
